module.exports = __webpack_public_path__ + "img/ios1icon2.06fe3824.png";